import i18next from "i18next";
import React from "react";
import { Input } from "reactstrap";
import { Keys } from "Translation/Setup";

const trainClasses = [
  { label: i18next.t(Keys.WORKFLOW.Train.trainClasses.first), value: "1" },
  { label: i18next.t(Keys.WORKFLOW.Train.trainClasses.second), value: "2" }
];
interface Props {
  onChange: (value: number) => void;
  value: number;
}
export const RailFlyClassField = (props: Props) => {
  const value = props.value || "";

  const handleChange = (e: any) => {
    props.onChange(e.target.value);
  };

  return (
    <Input type="select" value={value} onChange={handleChange}>
      {trainClasses.map((o, i) => (
        <option key={i} value={o.value!}>
          {o.label}
        </option>
      ))}
    </Input>
  );
};
